import { render, staticRenderFns } from "./DonutChartLabel.vue?vue&type=template&id=5d812ce0&scoped=true&"
import script from "./DonutChartLabel.vue?vue&type=script&lang=js&"
export * from "./DonutChartLabel.vue?vue&type=script&lang=js&"
import style0 from "./DonutChartLabel.vue?vue&type=style&index=0&id=5d812ce0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d812ce0",
  null
  
)

export default component.exports